import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box, Container } from "@mui/material";
import PageTitle from "../../components/common/pages/PageTitle";
import { observer } from "mobx-react";
import DynamicTable from "../../components/tables/DynamicTable";
import LoaderOverlay from "../../components/common/pages/AppLoader";
import NoData from "../../components/common/table/NoData";
import ReportDataAPI from "../../../api/ReportDataAPI";

const DataReport: React.FC = () => {
  const location = useLocation();
  const reportDataAPI = new ReportDataAPI();

  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [reportTitle, setReportTitle] = useState("");
  const [report, setReport] = useState<any[] | null>(null);

  const fetch_data = async () => {
    try {
      // Parse query params from the URL
      const paramsObject: Record<string, string> = {};

      // Convert them into a plain object
      searchParams.forEach((value, key) => {
        paramsObject[key] = value;
      });

      setReportTitle(paramsObject["title"] ?? "");

      if (paramsObject["base_url"] && paramsObject["path"]) {
        const url = `${paramsObject["base_url"]}${paramsObject["path"]}`;
        setLoading(true);
        const response = await reportDataAPI.getReportData(url, paramsObject);
        setReport(response);
      }
    } catch (err) {
      console.log("Report Data API Error", err);
      setReport([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch_data();
  }, [location.search]);

  return (
    <>
      <LoaderOverlay loading={loading} />
      <Container maxWidth="xl">
        {reportTitle !== "" ? (
          <PageTitle title={"Report - " + reportTitle} />
        ) : (
          <PageTitle title={"Report"} />
        )}
        {report && (
          <Box sx={{ maxHeight: window.innerHeight - 180 }}>
            {report.length > 0 ? (
              <DynamicTable title={reportTitle} report={report} />
            ) : (
              <>
                <NoData message="Oops! Nothing to show here." />
              </>
            )}
          </Box>
        )}
      </Container>
    </>
  );
};

export default observer(DataReport);
